// Arts
import image1 from "./Arts/VelhoOeste.png";
import image2 from "./Arts/Sapo.png";
import image3 from "./Arts/Aurelion_Smol.png";

// Particle Life
import particle1 from "./Particle Life/Image1.png";
import particle2 from "./Particle Life/Image2.png";
import particle3 from "./Particle Life/Image3.png";

// Evolutionary Robotic Arm
import robot1 from "./Evolutionary Robotic Arm/Image1.png";
import robot2 from "./Evolutionary Robotic Arm/Image2.png";
import robot3 from "./Evolutionary Robotic Arm/Image3.png";

// Recommendation System
import hermes1 from "./Hermes Recommendation System/Image1.png";
import hermes2 from "./Hermes Recommendation System/Image2.png";
import hermes3 from "./Hermes Recommendation System/Image3.png";

// Desktop Pet

import pet1 from "./Desktop Pet/Image1.png"
import pet2 from "./Desktop Pet/Image2.png"
import pet3 from "./Desktop Pet/Image3.png"

// Flags
import brazil from "./Flags/brazil-flag-icon.webp";
import usa from "./Flags/united-states-flag-icon.webp";

// Logos
import github from "./Logos/Github.png";
import itchio from "./Logos/itchio.svg";
import instagram from "./Logos/Instagram.png";
import linkedin from "./Logos/Linkedin.png";

export const bannerImages = [image1, image2, image3];
export const particleImages = [particle1, particle2, particle3];
export const robotImages = [robot1, robot2, robot3];
export const recommendationImages = [hermes1, hermes2, hermes3];
export const petImages = [pet1, pet2, pet3];

export const flags = {
    brazil,
    usa
};

export const logos = {
    github,
    itchio,
    instagram,
    linkedin
};